import { firebaseDb, firebaseStorage, firebaseAuth } from './firebase'
import { Collection, FirebaseError, AppError } from '../config/enums'
import { friendlyMessageFor } from '../utility/errorHelper'
import { toast } from 'react-toastify'
import { categoryConverter, Category } from '../models/Category'

/**
 * Retrieves the list of categories
 */
export const getCategories = async (): Promise<Category[]> => {
  let categories: Category[] = []

  try {
    const snapshot = await firebaseDb
      .collection(Collection.categories)
      .orderBy('name', 'asc')
      .withConverter(categoryConverter)
      .get()

    snapshot.forEach(doc => {
      categories.push(doc.data())
    })
  } catch (err) {
    console.error(err)
  }

  return categories
}

/**
 * Uploads a file to Firebase Storage
 *
 * @param file File to be uploaded
 * @param folder Optional folder to place the file (default location is /uploads)
 */
export const uploadFile = async (
  file: File,
  folder?: string
): Promise<string | null> => {
  try {
    const fileName = +new Date() // use current timestamp to keep the filename unique
    const ext = file.type.substring(file.type.indexOf('/') + 1)
    const path = folder
      ? `${folder}/${fileName}.${ext}`
      : `uploads/${fileName}.${ext}`

    const ref = firebaseStorage.ref().child(path)
    await ref.put(file)

    return ref.getDownloadURL()
  } catch (err) {
    console.error(err)
    return null
  }
}

/**
 * Changes the password from firebase auth
 *
 * @param currentPassword Old password
 * @param newPassword New password
 *
 */

export const changePassword = async (
  currentPassword: string,
  newPassword: string,
  email: string | null | undefined
): Promise<boolean> => {
  if (email !== null || email !== undefined) {
    var cred = firebaseAuth.EmailAuthProvider.credential(
      email!,
      currentPassword!
    )
    var user = firebaseAuth().currentUser!
    let authenticateUser = await user
      .reauthenticateWithCredential(cred)
      .catch(error => {
        toast.warn(friendlyMessageFor(error.code))
        return
      })
    if (authenticateUser === undefined) {
      return false
    } else {
      await user.updatePassword(newPassword!).catch(error => {
        let message = friendlyMessageFor(error.code)
        if (error.code === FirebaseError.authWrongPassword) {
          message = friendlyMessageFor(AppError.currentPasswordIncorrect)
        }
        toast.error(message)
        return
      })
    }

    let success = await firebaseAuth()
      .signInWithEmailAndPassword(email!, newPassword!)
      .catch(error => {
        console.log(error.code)
        toast.warn(friendlyMessageFor(error.code))
        return
      })
    console.log('success', success)

    if (success) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export const deleteFile = async (fileReference: string): Promise<boolean> => {
  const fileReferenceFromURL = firebaseStorage.refFromURL(fileReference)
  const deleteFile = await fileReferenceFromURL.delete()

  if (deleteFile) {
    return true
  } else {
    return false
  }
}
